export default __webpack_public_path__ + "static/media/pizza.95f901ff.jpeg";